import { MapDispatchToPropsFunction } from 'react-redux'
import { connectLoadable } from 'helpers/loadableHelpers'
import { focus, change } from 'redux-form'
import { Guards } from 'interfaces/guards'
import { State } from 'interfaces/state'
import { PeergroupFormType } from 'interfaces/peergroups'
import { FORM_CREATE_CUSTOM_PEER_GROUP, FORM_EDIT_CUSTOM_PEER_GROUP } from 'constants/forms'
import PeergroupForm, { PeergroupFormDispatchProps, PeergroupFormStateProps } from 'components/features/pfm/PeergroupForm/PeergroupForm'
import { closePeergroupFormActionCreator } from 'actions/sidebarActions'
import {
  resetPeergroupFiltersActionCreator,
  setPeergroupFiltersPopupShown,
  addPeergroupFilterActionCreator,
  deletePeergroupFilterActionCreator,
} from 'actions/peergroupActions'
import { getPeergroupFieldByFilter } from 'helpers/peergroupsHelpers'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import { peergroupsGuard } from 'guards/globalGuards'
import { peergroupSelectFilterOptionsSelector } from 'selectors/peergroupFormSelectors'

// TODO rewrite using selectors
const mapStateToProps = (state: State): PeergroupFormStateProps => {
  const { app, data, form } = state
  const { relations } = data.peergroups
  const {
    selectedFilters,
    isFiltersPopupShown,
    isPeergroupSearching,
    currentGroup,
    formMode,
  } = app.sidebar.peergroupForm

  const selectOptions = peergroupSelectFilterOptionsSelector(state)

  const formType: PeergroupFormType = formMode.mode === 'create'
    ? FORM_CREATE_CUSTOM_PEER_GROUP
    : FORM_EDIT_CUSTOM_PEER_GROUP
  const peergroupForm = form[formType]
  const formValues = peergroupForm && peergroupForm.values ? { ...peergroupForm.values } : {}

  return {
    formValues,
    // initialValues: peergroupForm && peergroupForm.initial ? peergroupForm.initial : {},
    currentGroup,
    relationId: formMode.mode === 'edit' ? formMode.id : null,
    relations: getItemsFromCollection(relations),
    isFiltersPopupShown,
    isPeergroupSearching,
    selectedFilters,
    selectOptions,
    form: formType,
  }
}

const mapDispatchToProps: MapDispatchToPropsFunction<PeergroupFormDispatchProps> = (dispatch) => ({
  hideSidebarForm: () => dispatch(closePeergroupFormActionCreator()),
  resetPeergroupFilters: () => dispatch(resetPeergroupFiltersActionCreator()),
  setFiltersPopupShown: (isVisible) => dispatch(setPeergroupFiltersPopupShown(isVisible)),
  addPeergroupFilter: (filter) => dispatch(addPeergroupFilterActionCreator(filter)),
  removePeergroupFilter: (form, filter) => {
    dispatch(deletePeergroupFilterActionCreator(form, filter))
    dispatch(change(form, getPeergroupFieldByFilter(filter), null))
  },
  focusFormField: (form, field) => dispatch(focus(form, field)),
})

const peergroupFormGuards: Guards = [
  peergroupsGuard,
]

const PeergroupFormContainer = connectLoadable(peergroupFormGuards)(mapStateToProps, mapDispatchToProps)(PeergroupForm)
export default PeergroupFormContainer
